"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
class HttpClient {
    constructor(apiURL) {
        this.axios = axios_1.default.create({
            baseURL: apiURL,
            responseType: "json",
            headers: {
                "Content-type": "application/json",
            },
        });
    }
    get(path, config) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axios.get(path, config);
            return response.data;
        });
    }
    post(path, data, config) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axios.post(path, data, config);
            return response.data;
        });
    }
    put(path, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axios.put(path, data);
            return response.data;
        });
    }
    patch(path, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axios.patch(path, data);
            return response.data;
        });
    }
    delete(path, config) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axios.delete(path, config);
            return response.data;
        });
    }
}
exports.default = HttpClient;
